<template>
    <div>
        <div class="mb-4">
            <SegmentTab v-model="tab" :items="tabs"></SegmentTab>
        </div>
        <HistoryList
            ref="history-list"
            :initListConfig="listConfig"
            :initFilterConfig="filterConfig"
            :modalController="modalController"
            :selectedTab="tab"
            @onRefreshList="setupList()"
        ></HistoryList>
    </div>
</template>
<script>
import SegmentTab from "@/components/Tab/SegmentTab.vue";
import HistoryList from "@/module/History/component/HistoryList.vue";
import LocaleMixin from "@/mixin/LocaleMixin";
import ConfigManager from "@/config/ConfigManager";
import {
    PurchaseFilterConfigBuilder,
    PurchaseListConfigBuilder,
} from "@/core/History/config/HistoryConfigModel.js";

export default {
    name: "PromotionHistory",
    mixins: [LocaleMixin],
    components: {
        SegmentTab,
        HistoryList,
    },
    props: {
        modalController: { type: Object, required: true },
    },
    data: function () {
        return {
            tab: 0,
            listConfig: null,
            filterConfig: null,
        };
    },
    computed: {
        tabs: function () {
            return [
                this.lbl.promotion.historyTabs.available,
                this.lbl.promotion.historyTabs.usedExpired,
            ];
        },
    },
    watch: {
        tab: function () {
            this.setupList();
        },
    },
    created: function () {
        this.buildConfig();
    },
    mounted: function () {
        window.addEventListener("scroll", this.onScroll);
        this.$refs["history-list"].getList();
    },
    beforeUnmount: function () {
        window.removeEventListener("scroll", this.onScroll);
    },
    methods: {
        buildConfig: function () {
            const configs = ConfigManager.getHistoryConfig();
            const config = this.tab == 0 ? configs.purchaseUnused : configs.purchaseUsed;
            this.listConfig = new PurchaseListConfigBuilder()
                .setConfigList(config)
                .setType("list")
                .setTop(25)
                .create();
            this.filterConfig = new PurchaseFilterConfigBuilder().create();
        },
        setupList: function () {
            this.buildConfig();
            if (this.$refs["history-list"]) {
                this.$refs["history-list"].reinitList(
                    this.listConfig,
                    this.filterConfig
                );
            }
        },
        onScroll: function () {
            const scrollOffSet = 100;
            const pageHeight = Math.max(
                window.pageYOffset,
                document.documentElement.scrollTop,
                document.body.scrollTop
            );
            const bottomOfWindow =
                pageHeight + window.innerHeight >
                document.documentElement.offsetHeight - scrollOffSet;
            if (bottomOfWindow) {
                this.$refs["history-list"].loadMore();
            }
        },
    },
};
</script>
